import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from "react-router-dom";
import axios from 'axios';
import Spinner from '../Spinner';
import donwIcon from '../img/download.svg';
import img3d from '../img/3d.png';
import imglicencia from '../img/licencia.png';
//import favIcon from '../img/favorito.svg';
import shareIcon from '../img/compartir.svg';

import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    EmailShareButton,
    FacebookIcon,
    TwitterIcon,
    WhatsappIcon,
    LinkedinIcon,
    EmailIcon,
  } from 'react-share';

export default function Proyecto() { 
    
    let { id } = useParams();

    const API_BASE = "https://www.ies21.edu.ar/hackaton3d/";

    const [item, setItem] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    let locationURL = useLocation();
    let shareUrl = API_BASE+locationURL.pathname;

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const result = await axios(`${API_BASE}projects.php?id=${id}`);
                setItem(result.data.results[0]);
                document.title = "Hackaton 3d :: "+result.data.results[0].titulo;
            }catch (error) {
                setIsLoading(false);
            }
            setIsLoading(false);
        };
        fetchData();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="row">
            {isLoading ? <Spinner txt="Consultando proyecto..." /> : 
                <div className="col mt-3 mb-5">
                    <h2 className="mb-5 text-uppercase">{item.titulo}</h2>
                    <div className="card-img-top imgtopcard" style={{height:`${item.imgH}px`, backgroundImage:`url(${item.upload_name_imagen})`}}>

                    </div>
                    {/* <img className="card-img-top" src={item.upload_name_imagen} alt={item.titulo} /> */}
                    <div className="mt-4"></div>

                    <table className="btnIc"><tbody><tr>
                        <td>
                            <a href={item.upload_name_file} download className="btn btn-default m-1"> 
                                <table className="btnIc"><tbody><tr><td><img src={donwIcon} className="fa" alt="download"/></td>
                                <td>Descargar proyecto</td></tr></tbody></table>                         
                            </a>
                        </td>
                        {/* <td>
                            <a href="#" className="btn btn-default m-1"> 
                                <table className="btnIc"><tbody><tr><td><img src={favIcon} className="fa" alt="favorito"/></td></tr></tbody></table>                         
                            </a>
                        </td> */}
                        <td>
                            <div className="dropdown">
                                <button className="btn btn-default m-1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> 
                                    <table className="btnIc"><tbody><tr><td><img src={shareIcon} className="fa" alt="compartir"/></td></tr></tbody></table>                         
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <FacebookShareButton className="dropdown-item" quote={item.titulo} url={shareUrl}>
                                        <FacebookIcon size={32} round={true} />
                                    </FacebookShareButton>
                                    <LinkedinShareButton className="dropdown-item" windowWidth={750} windowHeight={600} url={shareUrl}>
                                        <LinkedinIcon size={32} round={true} />
                                    </LinkedinShareButton>
                                    <TwitterShareButton className="dropdown-item" title={item.titulo} url={shareUrl}>
                                        <TwitterIcon size={32} round={true} />
                                    </TwitterShareButton>
                                    <WhatsappShareButton className="dropdown-item" title={item.titulo} url={shareUrl} separator=":: ">
                                        <WhatsappIcon size={32} round={true} />
                                    </WhatsappShareButton>
                                    <EmailShareButton className="dropdown-item" subject={item.titulo} url={shareUrl} >
                                        <EmailIcon size={32} round={true} />
                                    </EmailShareButton>
                                </div>
                            </div>
                        </td>
                    </tr></tbody></table>
                    
                    
                    <h5 className="mt-5">Acerca del proyecto</h5>
                    <p>{item.descripcion}</p>
                    <hr />
                    <h5 className="mt-4">Autores</h5>
                    <p>{item.autores}</p>
                    <p>{item.email}</p>
                    <hr />
                    <img src={img3d} alt="3d" />
                    <h5 className="mt-4">Sugerencias de impresión</h5>
                    <p>{item.sugerencias_impresion}</p>
                    <hr />
                    <img src={imglicencia} alt="Licencia" />
                    <h5 className="mt-4">Licencia</h5>
                    <p>Usted es libre de: Compartir, copiar y redistribuir el material en cualquier medio o formato. Adaptar, remezclar, transformar y construir a partir del material, con fines benéficos, tanto usted siga los términos de la licencia:<br /><br />

                    <u>Atribución</u>: Usted debe dar crédito de manera adecuada, brindando un enlace a esta página de licencia, e indicar si se han realizado cambios. </p>
                </div>
                    
            }
        </div>    
    );
}